import request from "@/API/request";

export function getComponyList(data) {
    return request({
        url: '/resource/api/companies/normal/page',
        method: 'get',
        params:data
    });
}
